import { NgbDateAdapter, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
// const moment = require('moment');
import * as moment from 'moment';

@Injectable()
export class DotNetDateAdapter extends NgbDateAdapter<string>
{
  public fromModel(date: string | null): NgbDateStruct | null {
    let dtReturn: NgbDateStruct | null;
    /* 2019-08-01T00:00:00 */
    if (date !== null && date.length >= 10) {
      dtReturn = {
        year: Number.parseInt(date.substr(0, 4), 10),
        month: Number.parseInt(date.substr(5, 2), 10),
        day: Number.parseInt(date.substr(8, 2), 10)
      };
    } else {
      dtReturn = null;
    }
    return dtReturn;
  }

  public toModel(date: NgbDateStruct | null): string | null {
    let dtReturn: string | null;
    if (date !== null) {
      const sMonth: string = date.month > 9 ? `${date.month}` : `0${date.month}`;
      const sDay: string = date.day > 9 ? `${date.day}` : `0${date.day}`;
      const currentTime: string = moment().format('HH:mm:ss');
      dtReturn = `${date.year}-${sMonth}-${sDay}T${currentTime}`;
    } else {
      dtReturn = null;
    }
    return dtReturn;
  }
}

@Injectable()
export class DateHelper {
  static readonly DT_FORMAT = 'DD-MM-YYYY';
  public dateFormat_iso(value: any): string {
    const dtParsed: Date | null = this.parse_iso(value);
    if (dtParsed) {
      // return moment(dtParsed).toISOString();
      return moment(dtParsed).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    } else {
      return '';
    }
  }

  public dateFormat_es(value: any): string {
    const dtParsed: Date | null = this.parse_iso(value);
    if (dtParsed)
    {
      return moment(dtParsed).format(DateHelper.DT_FORMAT);
    }
    else
    {
      return '';
    }
  }

  public parse_iso(value: any): Date | null
  {
    if (value)
    {
      const mdt = moment(value, moment.ISO_8601);
      return mdt.toDate();
    }
    return null;
  }

  public parse_es(value: string): Date | null {
    if (value)
    {
      value = value.trim();
      const mdt = moment(value, DateHelper.DT_FORMAT);
      return mdt.toDate();
    }
    return null;
  }
}

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  readonly DT_FORMAT = 'DD-MM-YYYY';
  isNumber(t: any): boolean
  {
    let bIsNumber = false;
    if (typeof t === 'number')
    {
      bIsNumber = true;
    }
    return bIsNumber;
  }

  parse(value: string): NgbDateStruct | null
  {
    if (value)
    {
      value = value.trim();
      const mdt = moment(value, this.DT_FORMAT);
      const dReturn: NgbDateStruct =
      {
        day: mdt.date(),
        month: mdt.month(),
        year: mdt.year()
      };
      return dReturn;
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    if (date)
    {
      const mdt = moment([date.year, date.month - 1, date.day]);
      return mdt.format(this.DT_FORMAT);
    }
    else
    {
      return '';
    }
  }
}
